/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BusinessResponse } from '../../models/business-response';

export interface GetBusiness$Params {
}

export function getBusiness(http: HttpClient, rootUrl: string, params?: GetBusiness$Params, context?: HttpContext): Observable<StrictHttpResponse<BusinessResponse>> {
  const rb = new RequestBuilder(rootUrl, getBusiness.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BusinessResponse>;
    })
  );
}

getBusiness.PATH = '/business';
